import { Check } from '@components/primitives/AnimatedIcon/Check';
import { Copy } from '@components/primitives/AnimatedIcon/Copy';
import { CopyCheck } from '@components/primitives/AnimatedIcon/CopyCheck';

export const AnimatedIcon = {
  Check,
  Copy,
  CopyCheck,
};
